import React, { ReactElement, useEffect, useState } from 'react';
import { Clusterer, Map, Placemark, Polyline, PolylineGeometry, YMaps } from 'react-yandex-maps';
import { useYandexTermsLinks } from "@common/hooks/useYandexTermsLinks";

interface IProp {
  height: number;
  mapState: any;
  points: {
    content: number;
    coords: number[];
    id: string;
    onClick: () => void;
  }[];
  polyline?: PolylineGeometry;
}

export const YandexMap = (
  {
    height,
    mapState,
    points = [],
    polyline = [],
  }: IProp
): ReactElement => {
  const [ymaps, setYmaps] = useState(null); // это ссылка на yandex-map API
  const [mapRef, setMapRef] = useState(null);
  useYandexTermsLinks();

  useEffect(() => {
    if (ymaps && mapRef) {
      if (points?.length > 1) {
        mapRef.setBounds(ymaps.util.bounds.fromPoints(points.map(p => p.coords)), { checkZoomRange: true });
      }
      if (points?.length === 1) {
        mapRef.setCenter(points[0].coords);
      }
    }
  }, [ymaps, points]);

  useEffect(() => {
    if (mapRef) {
      // удаление стандартных модулей управления
      // ссылка на документацию яндекса https://yandex.ru/dev/maps/jsapi/doc/2.1/dg/concepts/controls/work.html
      mapRef.controls.remove('geolocationControl');
      mapRef.controls.remove('searchControl');
    }
  }, [mapRef]);

  return (
    <YMaps
      query={{
        load: 'package.full'
      }}
    >
      <Map
        height={height}
        width={'auto'}
        options={{
          suppressMapOpenBlock: true,
        }}
        onLoad={ymap => {
          setYmaps(ymap)
        }}
        defaultState={{ controls: ['zoomControl'], ...mapState }}
        instanceRef={ref => {
          setMapRef(ref)
        }}
        modules={[
          'templateLayoutFactory',
          'clusterer.addon.balloon',
        ]}
      >{}
        <Clusterer
          options={{
            preset: 'islands#invertedVioletClusterIcons',
            groupByCoordinates: false,
            gridSize: 1 // из-за установленого gridSize 1 Placemark не будет сбиватся в кластер
          }}
        >
          {points?.length > 0 ? points.map((item, index) => (
            <Placemark
              key={index}
              geometry={item.coords}
              properties={{
                iconContent: item.content ? `<div style="width: 18px">${item.content}</div>` : undefined
              }}
              modules={['geoObject.addon.balloon', 'geoObject.addon.hint']}
              options={{
                draggable: false,
                preset: 'islands#icon',
                iconImageSize: [40, 52],
                iconColor: '#058181',
                iconImageOffset: [-5, -38],
                iconContent: '1'
              }}
              onClick={item.onClick}
            />
          )) : ''}
        </Clusterer>
        {(polyline && polyline.length > 0) && (
          <Polyline
            geometry={polyline}
            options={{
              strokeWidth: 3,
              strokeOpacity: 1,
              strokeColor: '#058181'
            }}
          />
        )}
      </Map>
    </YMaps>
  );
};
